import { useContext, useState } from "react";
import NetworkError from "../../components/NetworkError";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { config } from "../../constants/config";
import { useEffect } from "react";
import Preloader from "../../components/Preloader";
import { Link, useNavigate } from "react-router-dom";
import Increment from "../../components/increments/increment";
import UserContext from "../../contexts/UserContext";
import PaginationSelect from "../../components/sPaginationSelect";



export default function Increments() {
    // states
    const navigate = useNavigate();
    const { user, logoutUser } = useContext(UserContext);
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [error, setError] = useState(false);
    const [increments, setIncrements] = useState([]);
    const [nbpage, setNbpage] = useState(1);
    const [page, setPage] = useState(0);
    const [currentpage, setCurrentpage] = useState('');


    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const getListIncrements = async (p) => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("Authorization", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.token);

        // var urlencoded = new URLSearchParams();
        // urlencoded.append("cpte", user.code);
        // urlencoded.append("prof", user.profil);
        // urlencoded.append("conn", user.token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}:${config.secure.PORT}/${config.secure.PROJECT}/increment?limit=${config.secure.limit}&page=${p}`, requestOptions).then((response) => {

            if (response?.status !== 200) {
                setError(true);
                setLoading(false);
            } else {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        if (data.body?.data.length !== undefined) {
                            clientarray = data?.body?.data;
                            setNbpage(data?.body?.counter?.nbpage);
                        } else {
                            clientarray.push(data?.body);
                        }

                        // console.log("liste in data", clientarray)
                        setIncrements(clientarray);
                        setLoading(false);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: "Your session expired." } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                })
            }

        })
            .catch((err) => {
                // console.log("error", err);
                setError(true);
                setLoading(false);
            });
    }


    // comportements
    useEffect(() => {
        getListIncrements(page);
    }, []);

    const handleDelete = async (nomtab) => {
        confirmAlert({
            title: 'Delete?',
            message: 'Are you sure you want to delete this increment?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setFetching(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("Authorization", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.token);

                        // var urlencoded = new URLSearchParams();
                        // urlencoded.append("zone", codeac);
                        // urlencoded.append("abr", abrev);
                        // urlencoded.append("cont", desc);
                        // urlencoded.append("typacc", type["value"]);
                        // urlencoded.append("img", logoprev);

                        var requestOptions = {
                            method: 'DELETE',
                            headers: myHeaders,
                            // body: urlencoded,
                            redirect: 'follow'
                        };


                        // console.log("data send", urlencoded);

                        await fetch(`${config.secure.BASE_URL}:${config.secure.PORT}/${config.secure.PROJECT}/increment/${nomtab}`, requestOptions).then((response) => {
                            if (response?.status !== 200) {
                                // setError(true);

                                showErrorMessage(config.texts.unavailblemsg);
                                setFetching(false);
                            } else {
                                response.json().then(async (data) => {
                                    // console.log("delete incrément", data);
                                    let body = data?.body;

                                    if (!data?.head) {
                                        if (body?.msg === "expiredsession") {
                                            logoutUser();
                                            navigate("/", { state: { msg: "Your session expired." } });
                                        } else {
                                            setFetching(false);
                                            showErrorMessage(config.texts.failmsg);
                                        }
                                    } else {
                                        setFetching(false);
                                        showSuccesMessage("Increment added successfully.");
                                        getListIncrements();
                                    }

                                })
                            }

                        })
                            .catch((err) => {
                                // console.log("error", err);
                                // setError(true);
                                showErrorMessage(config.texts.unavailblemsg);
                                setFetching(false);
                            });
                    }
                },
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }


    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="container-fluid">
                <h1 className="h4 mb-4 font-weight-bold text_primary">Increments</h1>
                <div className="row">
                    <div className="col-md-2 mb-3">
                        <PaginationSelect nbpage={nbpage} getList={getListIncrements} page={page} setPage={setPage} current={currentpage} setCurrent={setCurrentpage} />
                    </div>
                    <div className="col-md-10 mb-3">
                        {/*  <Search 
                                        chaine={chaine}
                                        setChaine={setChaine}
                                        search={searchEmployee}
                                        placeholder="Rechercher un incrément"
                                    /> */}
                    </div>
                    <div className="col-md-12">
                        <div className="card shadow mb-4">
                            <div className="card-header py-3">
                                <Link to="/new-increment" data-toggle="tooltip" title="New increment" data-placement="left" className="btn-shadow ml-3 btn btn-primary btn-sm float-right">
                                    <i className="fa fa-plus mr-1"></i> <span>New increment</span>
                                </Link>
                                <h6 className="m-0 ">List of increment</h6>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive mb-3">
                                    <table className="mb-0 table table-bordered">
                                        <thead className="bg-primary">
                                            <tr className="bg-primary text-white">
                                                <th className="text-center">#</th>
                                                <th>Table name</th>
                                                <th>Préfix</th>
                                                <th>increment</th>
                                                <th>Created date</th>
                                                <th className="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(increments.length === 0) && <tr style={{ borderStyle: "none" }}>
                                                <th colSpan={6} className="text-center">No increment found</th>
                                            </tr>}
                                            {
                                                (increments.length > 0) && increments?.map((item, index) => (
                                                    <Increment increment={item} position={(config.secure.limit * page) + index} key={index}
                                                        deleteClick={() => handleDelete(item?.nomtable)}
                                                    />
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </div>}
        </>
    )

}